import React from 'react';
import { generateAcronym, getProjectColor } from '../../utils/string';
import './project-badge.css';

export const ProjectBadge = ({ projectName }) => {
  if (!projectName) return null;

  const acronym = generateAcronym(projectName);
  const colors = getProjectColor(projectName);
  
  return (
    <div 
      className="project-badge"
      style={{
        backgroundColor: colors.bg,
        borderColor: colors.border,
      }}
    >
      <span 
        className="project-badge-text"
        style={{
          color: colors.text,
        }}
      >
        {acronym}
      </span>
    </div>
  );
};
